<markant-platform-modal-bridge>
  <markant-dialog
    class="dialog-usage-right"
    [open]="true"
    (close)="closeDialog(false)"
  >
    <h2>{{ 'usageRight.dialog.headline' | transloco }}</h2>

    <div class="dialog-sub-title">
      <span>{{ 'usageRight.dialog.explanation' | transloco }}</span>
    </div>

    <form [formGroup]="form">
      <markant-callout
        *ngIf="usageRight.state === usageRightStates.STOPPED"
        colorScheme="warning"
        removeable="false"
        theme="colored"
      >
        <div slot="content" class="markant-callout-content">
          <markant-icon icon="m_info"></markant-icon>
          <p>{{ 'usageRight.dialog.disabledHint' | transloco }}</p>
        </div>
      </markant-callout>

      <markant-callout
        *ngIf="
          form.controls[usageRightFormControls.state].value ===
            usageRightStates.STOPPED &&
          usageRight.state !== usageRightStates.STOPPED
        "
        colorScheme="warning"
        removeable="false"
        theme="colored"
      >
        <div slot="content" class="markant-callout-content">
          <markant-icon icon="m_info"></markant-icon>
          <p>{{ 'usageRight.dialog.suspendedStateWarning' | transloco }}</p>
        </div>
      </markant-callout>

      <div
        class="dialog-form-error-message"
        *ngIf="form.hasError('startDateBeforeEndDate')"
      >
        <span>
          {{
            'organization.overview.edit.usage-right.intervalInvalid' | transloco
          }}
        </span>
      </div>

      <div class="dialog-form-selection">
        <markant-select
          label="{{ 'usageRight.state' | transloco }}"
          class="selection"
          required="true"
          outlined="true"
          [value]="usageRight.state"
          [formControlName]="usageRightFormControls.state"
          [options]="stateOptions"
          (valueChange)="onStateChanged($any($event).detail)"
        >
        </markant-select>

        <markant-select
          label="{{ 'usageRight.paymentModel' | transloco }}"
          class="selection"
          outlined="true"
          required="true"
          [formControlName]="usageRightFormControls.paymentModel"
          [value]="usageRight.paymentModel"
          [options]="paymentModelOptions"
        >
        </markant-select>
      </div>

      <h6 class="headline label">{{ 'usageRight.boughtAt' | transloco }}*</h6>
      <div class="dialog-form-date">
        <markant-datepicker
          class="date"
          type="date"
          dateFormat="d.m.Y"
          outlined="true"
          [formControlName]="usageRightFormControls.boughtAt"
        ></markant-datepicker>
      </div>

      <h6 class="headline">{{ 'usageRight.validity' | transloco }}*</h6>
      <div class="dialog-form-date validityPeriods">
        <markant-datepicker
          label="{{ 'common.from' | transloco }}"
          type="date"
          dateFormat="d.m.Y"
          outlined="true"
          useCustomLayout="true"
          [formControlName]="usageRightFormControls.validityPeriodStart"
        >
        </markant-datepicker>

        <div class="until">-</div>

        <markant-datepicker
          label="{{ 'common.until' | transloco }}"
          type="date"
          dateFormat="d.m.Y"
          outlined="true"
          useCustomLayout="true"
          [formControlName]="usageRightFormControls.validityPeriodEnd"
        >
        </markant-datepicker>
      </div>
    </form>

    <div class="dialog-form-footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        (click)="closeDialog(false)"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>

      <markant-button
        colorScheme="primary"
        [loading]="isLoading"
        [disabled]="form.invalid || !form.dirty"
        (click)="onSave()"
      >
        {{ 'organization.overview.edit.usage-right.save' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
